import * as PIXI from "pixi.js";
import { getViewport } from "./viewport.layer";
import { cull as customCull } from "../../../engines/interactionEngine/customCull";
import { throttle } from "@certa/catalyst/utils/common";

const updateCulling = throttle(() => {
  const viewport = getViewport();
  if (viewport.dirty) {
    customCull({ visibleBounds: viewport.getVisibleBounds() });
    viewport.dirty = false;
  }
}, 100);

export const initializeCulling = () => {
  const viewport = getViewport();
  if (viewport) {
    customCull({ force: true, visibleBounds: viewport.getVisibleBounds() });
  }

  PIXI.Ticker.shared.add(updateCulling, null, PIXI.UPDATE_PRIORITY.LOW);
};

export const uninitializeCulling = () => {
  PIXI.Ticker.shared.remove(updateCulling);
};
